/**
 * Bloomyer Événements — Compte à rebours multi-cartes
 * Custom element: <bev-events>
 */

if (!customElements.get('bev-events')) {
  class BevEvents extends HTMLElement {
    connectedCallback() {
      this.cards = [];
      this.querySelectorAll('.bev-card').forEach((card) => {
        const dateStr = card.dataset.targetDate;
        if (!dateStr) return;

        const target = new Date(dateStr).getTime();
        if (isNaN(target)) return;

        this.cards.push({
          target,
          daysEl: card.querySelector('[data-cd-days]'),
          hoursEl: card.querySelector('[data-cd-hours]'),
          minutesEl: card.querySelector('[data-cd-minutes]'),
          countdown: card.querySelector('.bev-countdown'),
        });
      });

      if (this.cards.length === 0) return;

      this.update();
      this.timer = setInterval(() => this.update(), 60000);

      this.initSlider();
    }

    disconnectedCallback() {
      if (this.timer) clearInterval(this.timer);
      if (this._onScroll) this.grid.removeEventListener('scroll', this._onScroll);
      if (this._onResize) window.removeEventListener('resize', this._onResize);
    }

    /* ---- Mobile slider dots ---- */
    initSlider() {
      this.grid = this.querySelector('.bev-grid');
      this.dotsEl = this.querySelector('.bev-dots');
      this.cardEls = [...this.querySelectorAll('.bev-card')];
      if (!this.grid || !this.dotsEl || this.cardEls.length <= 1) return;

      this.buildDots();

      let scrollRaf = null;
      this._onScroll = () => {
        if (scrollRaf) return;
        scrollRaf = requestAnimationFrame(() => {
          this.updateActiveDot();
          scrollRaf = null;
        });
      };
      this.grid.addEventListener('scroll', this._onScroll, { passive: true });

      this._onResize = () => this.updateActiveDot();
      window.addEventListener('resize', this._onResize);
    }

    buildDots() {
      this.dotsEl.innerHTML = '';
      this.cardEls.forEach((_, i) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'bev-dots__dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Aller à l\'événement ' + (i + 1));
        dot.addEventListener('click', () => {
          this.cardEls[i].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        });
        this.dotsEl.appendChild(dot);
      });
    }

    updateActiveDot() {
      if (!this.grid || !this.dotsEl) return;
      const center = this.grid.scrollLeft + this.grid.offsetWidth / 2;
      let activeIdx = 0;
      let minDist = Infinity;
      this.cardEls.forEach((card, i) => {
        const cardCenter = card.offsetLeft + card.offsetWidth / 2;
        const dist = Math.abs(cardCenter - center);
        if (dist < minDist) {
          minDist = dist;
          activeIdx = i;
        }
      });
      this.dotsEl.querySelectorAll('.bev-dots__dot').forEach((dot, i) => {
        dot.classList.toggle('is-active', i === activeIdx);
      });
    }

    update() {
      const now = Date.now();
      let allExpired = true;

      this.cards.forEach((c) => {
        const diff = c.target - now;

        if (diff <= 0) {
          if (c.daysEl) c.daysEl.textContent = '0';
          if (c.hoursEl) c.hoursEl.textContent = '0';
          if (c.minutesEl) c.minutesEl.textContent = '0';
          if (c.countdown) c.countdown.classList.add('bev-countdown--expired');
          return;
        }

        allExpired = false;
        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

        if (c.daysEl) c.daysEl.textContent = days;
        if (c.hoursEl) c.hoursEl.textContent = hours;
        if (c.minutesEl) c.minutesEl.textContent = minutes;
      });

      if (allExpired && this.timer) clearInterval(this.timer);
    }
  }

  customElements.define('bev-events', BevEvents);
}
